import Marquee from "react-fast-marquee";

const words = ["Scented Candles", "Floral Bouquets", "Plaster Figurines", "DIY Kits", "Hand-poured", "Made in Howrah"];

export default function EditorialMarquee() {
  return (
    <div className="py-10 border-y border-[#292524] bg-[#0C0A09]" data-testid="marquee">
      <Marquee speed={28} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-4xl sm:text-6xl text-[#F5F5F0] px-8">{w}</span>
            <span className="text-[#C4A47C] text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
